import React from 'react'
import './styles.scss'
interface Props {
  y: number[]
  x: number
  val: string
  hideLabel?: boolean
  textAnchor: 'start' | 'end' | 'middle'
}

export const VerticalTick = ({
  x,
  y,
  val,
  hideLabel = false,
  textAnchor = 'middle'
}: Props) => {
  return (
    <>
      <line x1={x} x2={x} y1={y[0]} y2={y[1]} className='tick' />
      {!hideLabel && (
        <text x={x} y={y[0] + 20} textAnchor={textAnchor} className='tick'>
          {val}
        </text>
      )}
    </>
  )
}
